<template>
  <!-- 投資型基本輸入：版型六　定期繳+彈性繳VA -->
  <div>
    <div class="row mt_16"><div class="col create_title">規劃保費</div></div>
    <!-- 保費 -->
    <div class="form-group d-flex align-items-end mt_20">
      <div class="d-flex text-norwap mr_8">
        <strong style="line-height: 40px">定期保費:</strong>
      </div>
      <div class="d-flex align-items-center mr_8">
        <!-- 繳別 -->
        <label>繳別:</label>
        <select
          class="form-control"
          style="width: 8rem"
          :id="'pay_freq'"
          data-vv-name="pay_freq"
          :class="{ 'is-invalid': errors.has('pay_freq') }"
          v-validate="`required`"
          data-vv-as="繳別"
          v-model="productDataScope.pay_freq"
          @change="getINVAmtLimitRanges()"
        >
          <option value="" disabled>請選擇</option>
          <option
            v-for="(payFreqOption, index) in option.payFreq_option"
            :key="index.paraval"
            :value="payFreqOption.paraval"
          >
            {{ payFreqOption.paradetlno }}
          </option>
        </select>
      </div>
      <div class="d-flex align-items-center mr_8">
        <!-- 繳別 -->
        <div style="line-height: 40px" class="mr_4">
          {{
            PRODUCT_FEATURE_DATA.pay_period_matur == "0" ? "年滿期" : "繳至:"
          }}
        </div>
        <div class="position-relative">
          <div class="notice-top text-red" style="left: -60px">
            定期保費繳至年齡須小於年金給付年齡
          </div>
          <div class="d-flex align-items-center">
            <!-- <label>{{
            PRODUCT_FEATURE_DATA.pay_period_matur == "0" ? "年滿期" : "繳至:"
          }}</label> -->
            <input
              type="tel"
              maxlength="3"
              class="form-control mr_2"
              style="width: 7rem"
              :id="'pol_endage'"
              :data-vv-name="'pol_endage'"
              :class="{ 'is-invalid': errors.has('pol_endage') }"
              v-validate="`required|pol_endage`"
              data-vv-as="繳至"
              @input="
                ageFormat(productDataScope, 'pol_endage');
                validateAll();
              "
              v-model.trim="productDataScope.pol_endage"
            />歲
          </div>
        </div>
      </div>
      <!-- 每期保費 -->
      <div class="d-flex align-items-center">
        <div style="line-height: 40px" class="mr_4">每期保費:</div>
        <div class="position-relative">
          <div
            class="notice-top text-red"
            v-if="PRODUCT_FEATURE_DATA.face_prem_incr_unit != '0'"
          >
            {{
              `需以${formatMethods(
                PRODUCT_FEATURE_DATA.face_prem_incr_unit
              )}${currTranser(PRODUCT_FEATURE_DATA.curr, true)}為單位`
            }}
          </div>
          <div class="d-flex align-items-center">
            <input
              type="tel"
              class="form-control mr_2"
              style="width: 175px"
              :class="{ 'is-invalid': errors.has('pol_premium') }"
              v-validate="`required|pol_premium`"
              :id="'pol_premium'"
              :data-vv-name="'pol_premium'"
              data-vv-as="每期保費"
              @input="
                numberHandler(productDataScope, 'pol_premium', $event);
                getINVAmtLimitRanges();
              "
              @blur="numberHandler(productDataScope, 'pol_premium', $event)"
              :value="productDataScope.pol_premium | formatMethods"
              :placeholder="
                productDataScope.pay_freq &&
                prem_limit[productDataScope.pay_freq]
                  ? `${formatMethods(
                      converIncrUnit(
                        prem_limit[productDataScope.pay_freq].prem_floor
                      )
                    )}~${formatMethods(
                      converIncrUnit(
                        prem_limit[productDataScope.pay_freq].prem_ceil
                      )
                    )}`
                  : ''
              "
            />
          </div>
        </div>
        <span>{{ currTranser(PRODUCT_FEATURE_DATA.curr, true) }}</span>
      </div>
    </div>
    <!-- 不定期保費 -->
    <div v-if="isUntmPrem" class="form-group d-flex align-items-center mt_20">
      <div class="d-flex mr_8">
        <strong style="line-height: 40px">不定期保費:</strong>
      </div>
      <!-- 新增繳費方式 -->
      <div class="position-relative d-inline-block">
        <a
          class="btn btn-default"
          style="line-height: 20px; height: 44px"
          @click="addPayMethods()"
        >
          新增繳費方式
        </a>
      </div>
      <div>可同時選定期保費、不定期保費，或僅選擇不定期保費</div>
    </div>
  </div>
</template>

<script>
import mf_Mixin from "@/desktop/views/mf/mixin";
import { Validator } from "vee-validate";
import moment from "moment";
export default {
  props: ["productDataScope", "mainIndex", "option"],
  mixins: [mf_Mixin],
  data() {
    return {
      amt_limit: null,
      prem_limit: [{}, {}, {}, {}],
      getINVPremiumLimitTimer: null,
      getINVAmtLimitTimer: null,
    };
  },
  computed: {
    PRODUCT_FEATURE_DATA() {
      return this.productDataScope.FEATURE_DATA;
    },
    amt_formatVal() {
      if (this.productDataScope.FEATURE_DATA.amt_unit == "") {
        return 1;
      } else {
        return this.$amtUnitFormat(this.productDataScope.FEATURE_DATA.amt_unit);
      }
    },
    MfEditing() {
      return this.$store.getters.MfEditing;
    },
    nowProduct() {
      return this.MfEditing.mc_prod_list[0];
    },
    isUntmPrem() {
      return this.productDataScope.FEATURE_DATA.is_untm_prem === "1";
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    async addPayMethods() {
      // const checkResult = await this.$validator.validateAll();
      // if (!checkResult) {
      //   this.$toast.info({
      //     title: "請檢視必填欄位是否漏填或填寫內容有誤!",
      //   });
      // } else
      if (
        this.productDataScope.dueage == undefined ||
        this.productDataScope.dueage == "" ||
        this.productDataScope.dueage == null
      ) {
        this.$bus.emit("event_dueage", this.productDataScope.dueage);
        this.$toast.info({
          title: "請檢視必填欄位是否漏填或填寫內容有誤!",
        });
      } else {
        this.productDataScope.dueage_tmp = this.productDataScope.dueage;
        this.$router.push("/mf/create/addPayment2");
      }
    },
    init() {
      // this.productDataScope.pol_endage_tmp = this.productDataScope.pol_endage;
      this.getINVLimitRanges();
    },
    async getINVLimitRanges() {
      let insured_actage = this.MfEditing.insured.insured_birthday
        ? moment().diff(
            moment(this.MfEditing.insured.insured_birthday),
            "years"
          )
        : this.MfEditing.insured.insured_age;
      let { amt_limit, prem_limit } =
        await this.$mfAPI.MFB1_0100__getINVLimitRanges({
          prod_id: this.nowProduct.prod_id,
          insured_actage: insured_actage,
          insured_age: this.MfEditing.insured.insured_age,
          insured_gender: this.MfEditing.insured.insured_gender,
        });
      this.amt_limit = amt_limit;
      this.prem_limit = prem_limit;
      this.initValidator();
    },
    async getINVAmtLimitRanges() {
      if (this.getINVAmtLimitTimer) {
        clearTimeout(this.getINVAmtLimitTimer);
      }
      this.$store.commit("update_canSave", false);
      this.getINVAmtLimitTimer = setTimeout(async () => {
        let vaild = this.productDataScope.pol_premium
          ? await this.$validator.validate(`pol_premium`)
          : false;
        if (vaild) {
          let amt_limit = await this.$mfAPI.MFB1_0100__getINVAmtLimitRanges({
            prod_id: this.nowProduct.prod_id,
            insured_actage: this.MfEditing.insured.insured_age,
            insured_age: this.MfEditing.insured.insured_age,
            insured_gender: this.MfEditing.insured.insured_gender,
            premium: this.productDataScope.pol_premium,
            pay_freq: this.productDataScope.pay_freq,
          });
          this.amt_limit = amt_limit;
        }
      }, 500);
    },
    initValidator() {
      //繳至
      Validator.extend(`pol_endage`, {
        getMessage: "",
        validate: (value) => {
          let insured_age = this.$store.getters.MfEditing.insured.insured_age;
          let insured_age_floor =
            this.$store.getters.MfEditing.insured.insured_age; //被保人年齡(檢核下限用，預設值:保險年齡)
          let { age_ceil, age_floor } = this.PRODUCT_FEATURE_DATA;
          //區分法定年齡與保險年齡邏輯(2022/3/18新增 )
          if (
            this.PRODUCT_FEATURE_DATA.age_floor_kind == "2" &&
            this.$store.getters.MfEditing.insured.insured_birthday != ""
          ) {
            insured_age_floor = this.$store.getters.MfEditing.insured
              .insured_birthday
              ? moment().diff(
                  moment(
                    this.$store.getters.MfEditing.insured.insured_birthday
                  ),
                  "years"
                )
              : this.$store.getters.MfEditing.insured.insured_age;
          }
          //判斷是否符合承保年齡上下限
          if (
            parseInt(age_ceil) < parseInt(insured_age) ||
            parseInt(age_floor) > parseInt(insured_age_floor)
          ) {
            return false;
          }
          //判斷繳至的年齡是否合法
          if (
            parseInt(value) >
              parseInt(this.PRODUCT_FEATURE_DATA.pay_prd.split("~")[1]) ||
            parseInt(value) < parseInt(insured_age)
          ) {
            return false;
          }

          if (
            this.productDataScope.dueage != undefined &&
            this.productDataScope.dueage != "" &&
            this.productDataScope.dueage != null
          ) {
            if (
              this.productDataScope.pol_endage != undefined &&
              this.productDataScope.pol_endage != "" &&
              this.productDataScope.pol_endage != null
            ) {
              if (
                parseInt(this.productDataScope.dueage) <=
                parseInt(this.productDataScope.pol_endage)
              ) {
                return false;
              }
            }
          }
          return true;
        },
      });
      Validator.extend(`pol_premium`, {
        getMessage: "",
        validate: (value) => {
          if (!this.productDataScope.pay_freq) return false;
          let intValue = parseInt(value.split(",").join(""));
          //符合保費遞增與保額上下限
          let incr_unit =
            this.PRODUCT_FEATURE_DATA.face_prem_incr_unit == "0"
              ? 1
              : this.PRODUCT_FEATURE_DATA.face_prem_incr_unit;
          return (
            (!this.productDataScope.pay_freq ||
              (intValue <=
                this.prem_limit[this.productDataScope.pay_freq].prem_ceil &&
                intValue >=
                  this.prem_limit[this.productDataScope.pay_freq]
                    .prem_floor)) &&
            intValue % incr_unit === 0
          );
        },
      });
    },
    converIncrUnit(number) {
      let face_prem_incr_unit =
        this.PRODUCT_FEATURE_DATA.face_prem_incr_unit == "0"
          ? 1
          : this.PRODUCT_FEATURE_DATA.face_prem_incr_unit;
      return Math.floor(number / face_prem_incr_unit) * face_prem_incr_unit;
    },
    async validateAll() {
      let VaildInput = await this.$validator.validateAll();
      return VaildInput;
    },
  },
  watch: {
    "productDataScope.dueage": {
      handler(newValue, oldVal) {
        if (
          this.productDataScope.pol_endage != undefined &&
          this.productDataScope.pol_endage != "" &&
          this.productDataScope.pol_endage != null
        ) {
          if (parseInt(newValue) < parseInt(this.productDataScope.pol_endage)) {
            document
              .getElementById("event_dueage")
              .setAttribute("class", "form-control is-invalid mr_2");
            document
              .getElementById("pol_endage")
              .setAttribute("class", "form-control is-invalid mr_2");
          } else {
            document
              .getElementById("pol_endage")
              .setAttribute("class", "form-control mr_2");
            document
              .getElementById("event_dueage")
              .setAttribute("class", "form-control mr_2");
          }
        }
      },
    },
    "productDataScope.pol_endage": {
      handler(newValue, oldVal) {
        if (
          this.productDataScope.dueage != undefined &&
          this.productDataScope.dueage != "" &&
          this.productDataScope.dueage != null
        ) {
          let insured_age = this.$store.getters.MfEditing.insured.insured_age;
          if (parseInt(newValue) >= parseInt(this.productDataScope.dueage)) {
            document
              .getElementById("pol_endage")
              .setAttribute("class", "form-control is-invalid mr_2");
            document
              .getElementById("event_dueage")
              .setAttribute("class", "form-control is-invalid mr_2");
          } else if (parseInt(newValue) < parseInt(insured_age)) {
            document
              .getElementById("pol_endage")
              .setAttribute("class", "form-control is-invalid mr_2");
          } else {
            document
              .getElementById("pol_endage")
              .setAttribute("class", "form-control mr_2");
            document
              .getElementById("event_dueage")
              .setAttribute("class", "form-control mr_2");
          }
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
label {
  margin-right: 8px !important;
  line-height: 40px;
  white-space: nowrap;
}
.yearPremiumLimit {
  display: inline-block;
  padding: 5px 10px 4px;
  background-color: #fff3c2;
  font-weight: 700;
}
</style>
